/* eslint-disable no-unused-vars */
import mediaService from '../services/media.service';

const initialState = { media: [], };

export const media = {
    namespaced: true,
    state: initialState,
    actions: {
        async getMedia({ commit }, id) {
            const media = await mediaService.getMedia(id);
            commit('getMediaSuccess', media);
            return media;
        },

        async deleteMedia({ commit }, options) {
            await mediaService.deleteMedia(options);
        },

        async downloadMedia({ commit }, options) {
            const downloadMedia = await mediaService.downloadMedia(options);
            commit('getDownloadMediaSuccess', downloadMedia);
        },
    },
    mutations: {
        getMediaSuccess(state, media) {
            state.media = media;
        },
        getDownloadMediaSuccess(state, downloadMedia) {
            state.downloadMedia = downloadMedia;
        },
    },
    getters: {
        getMediaData(state) {
            return state.media;
        },
        getDownloadMediaData(state) {
            return state.downloadMedia?.data;
        },
    }
}

